import { UserCircleIcon } from '@heroicons/react/outline';
import clsx from 'clsx';
import Link from 'next/link';
import Avatar from 'react-avatar';

export default function UserAvatar({ user, size = 32, className = '', showName = false }) {
  let userName = user && user.nickname ? user.nickname : user;
  let userAvatar = user && user.avatar ? user.avatar : '';
  let link = `/u/${userName}`;
  return (
    <>
      <Link id="user-av" href={link} className={clsx('my-auto flex', className)}>
        <Avatar
          className={clsx('rounded-full')}
          size={size}
          name={userName}
          src={userAvatar}
          round={true}
          alt={`Avatar użytkownika ${userName}`}
        />

        {showName && (
          <Link href={link} className="my-auto">
            <p className="truncate px-2 text-sm font-medium text-gray-900">{userName}</p>
          </Link>
        )}
      </Link>
    </>
  );
}
